import type { Service, WithContext } from "schema-dts";
import { ORG, STRUCTURED_DATA_IDS } from "@/content/_site.config";
import type { Metadata } from "@/content/types";

export function buildServiceFromSpec(
  seo: Metadata,
): WithContext<Service> | null {
  if (!seo.service) {
    return null;
  }

  const result: WithContext<Service> = {
    "@context": "https://schema.org",
    "@type": "Service",
    "@id": STRUCTURED_DATA_IDS.service(seo.canonical),
    url: `${ORG.url}${seo.canonical}`,
    serviceType: seo.service.serviceType,
    provider: { "@id": STRUCTURED_DATA_IDS.biz },
    // TODO: Add areaServed & description
  };

  if (seo.service.category) {
    result.category = seo.service.category;
  }

  if (seo.service.description) {
    result.description = seo.service.description;
  }

  if (seo.service.areaServed) {
    result.areaServed = seo.service.areaServed;
  }

  if (seo.service.isRelatedTo) {
    result.isRelatedTo = seo.service.isRelatedTo.map(href => ({
      "@id": `${ORG.url}${href}/#service`,
    }));
  }
  return result;
}
